import { render, staticRenderFns } from "./spotList.vue?vue&type=template&id=8dad1510&scoped=true&"
import script from "./spotList.vue?vue&type=script&lang=js&"
export * from "./spotList.vue?vue&type=script&lang=js&"
import style0 from "./spotList.vue?vue&type=style&index=0&id=8dad1510&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dad1510",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8dad1510')) {
      api.createRecord('8dad1510', component.options)
    } else {
      api.reload('8dad1510', component.options)
    }
    module.hot.accept("./spotList.vue?vue&type=template&id=8dad1510&scoped=true&", function () {
      api.rerender('8dad1510', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/scenicTutorials/components/spotList.vue"
export default component.exports